import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord'
import SearchIcon from '@mui/icons-material/Search'
import { IconButton, Paper, Typography } from '@mui/material'
import { DataGrid, GridRenderCellParams } from '@mui/x-data-grid'
import { Merchant } from '@src/data/types/Merchant'
import { useTranslation } from 'react-i18next'

interface PromoMerchantsTableProps {
  isLoading: boolean
  filteredMerchants: Merchant[]
  page: number
  rowsPerPage: number
  setPage: (v: number) => void
  setRowsPerPage: (v: number) => void
}

const PromoMerchantsTable = ({ isLoading, filteredMerchants, page, rowsPerPage, setPage, setRowsPerPage }: PromoMerchantsTableProps) => {
  const { t } = useTranslation()
  const columns: import('@mui/x-data-grid').GridColDef<Merchant>[] = [
    { field: 'name', headerName: t('merchant.name'), flex: 1, minWidth: 150 },
    { field: 'city', headerName: t('merchant.city'), flex: 1, minWidth: 120 },
    { field: 'province', headerName: t('merchant.province'), flex: 1, minWidth: 100 },
    { field: 'country', headerName: t('merchant.country'), flex: 1, minWidth: 120 },
    { field: 'zipCode', headerName: t('merchant.postalCode'), flex: 1, minWidth: 100 },
    {
      field: 'isActive',
      headerName: t('merchant.isActive', 'Actif'),
      flex: 0.5,
      minWidth: 80,
      align: 'center',
      headerAlign: 'center',
      renderCell: (params: GridRenderCellParams<Merchant, boolean>) => (
        <FiberManualRecordIcon style={{ color: params.value ? '#4caf50' : '#f44336', fontSize: 18 }} titleAccess={params.value ? t('common.yes', 'Oui') : t('common.no', 'Non')} />
      ),
    },
    {
      field: 'actions',
      headerName: '',
      sortable: false,
      filterable: false,
      align: 'center',
      headerAlign: 'center',
      width: 60,
      renderCell: (params: GridRenderCellParams<Merchant>) => (
        <IconButton
          color="primary"
          component="a"
          href={`/merchant/${params.row.id}/view`}
          title={t('common.viewDetails')}
        >
          <SearchIcon />
        </IconButton>
      ),
    },
  ]
  return (
    <Paper sx={{ p: 2, background: '#fafbfc', boxShadow: 1 }}>
      {isLoading ? (
        <Typography>{t('common.loading')}</Typography>
      ) : filteredMerchants.length === 0 ? (
        <Typography>{t('browsePromotionsMerchantDetails.noMerchantForPromo')}</Typography>
      ) : (
        <DataGrid
              rows={filteredMerchants.map((m) => ({ ...m, id: m.id ?? m.name }))}
          columns={columns}
          paginationModel={{ page, pageSize: rowsPerPage }}
          onPaginationModelChange={({ page, pageSize }) => {
            setPage(page)
            setRowsPerPage(pageSize)
          }}
          pageSizeOptions={[5, 10, 25, 50]}
          disableRowSelectionOnClick
          sx={{
            background: '#fff',
            fontSize: 15,
            '& .MuiDataGrid-columnHeaders': {
              background: '#f5f7fa',
              color: '#1976d2',
              fontWeight: 600,
              fontSize: 15,
            },
            '& .MuiDataGrid-cell': {
              color: '#222',
              fontSize: 15,
            },
            '& .MuiDataGrid-row': {
              '&:nth-of-type(even)': {
                backgroundColor: '#f5f5f5',
              },
              '&:nth-of-type(odd)': {
                backgroundColor: '#fff',
              },
            },
            '& .MuiDataGrid-row:hover': {
              background: '#f0f6ff',
            },
          }}
        />
      )}
    </Paper>
  )
}

export default PromoMerchantsTable
